const forEachParameter = parameters => {
  const keys = Object.keys(parameters);

  return {
    /**
     * It will call a callback for every Parameter in a multidimensional array
     * @param callback
     */
    do: callback => {
      for (let i = 0; i < keys.length; i += 1) {
        const parameter = parameters[keys[i]];
        if (Array.isArray(parameter)) {
          for (let a = 0; a < parameter.length; a += 1) {
            callback(parameter[a], keys[i]);
          }
        } else {
          callback(parameter, keys[i]);
        }
      }
    },
  };
};

export default forEachParameter;
